<template>
    <view-card headline="특별계약사항">
        <v-textarea v-model="value.specialTerms" rows="14" hide-details class="py-0 my-0" :readonly="readonly" />
    </view-card>
</template>
<script>
import viewCard from "../dumb/view-card.vue";
export default {
    components: { viewCard },
    props: {
        value: {
            specialTerms: { type: String, default: null },
        },
        readonly : {type:Boolean, default: true}
    },
};
</script>
